/**
 * SPDX-FileCopyrightText: (c) 2026 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';

const ClayTableHead = React.forwardRef<
	HTMLTableSectionElement,
	React.TableHTMLAttributes<HTMLTableSectionElement>
>(({children, ...otherProps}, ref) => {
	return (
		<thead {...otherProps} ref={ref}>
			{children}
		</thead>
	);
});

ClayTableHead.displayName = 'ClayTableHead';

export default ClayTableHead;
